import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { AmsRewardsService }           from './ams-rewards.service';
import { AmsRewardsSettingsComponent } from './ams-rewards.settings.component';
import { ApiService }                  from '../api/api.service';
import { CodeTypeModel }               from '../core/models/code-type';
import { CompanyIntegrationsModel }    from '../companies/models/company.integrations';
import { SessionService }              from '../sessions/session.service';

export const AmsRewardsStates : Array<NgHybridStateDeclaration> = [
  {
    component: AmsRewardsSettingsComponent,
    name     : 'app.ams-rewards-settings',
    resolve  : [
      {
        deps     : [ AmsRewardsService ],
        resolveFn: ( amsRewardsService : AmsRewardsService ) : ng.IPromise<Array<CodeTypeModel>> => amsRewardsService.getAutoClubs(),
        token    : 'amsAutoClubs'
      },
      {
        deps     : [ AmsRewardsService ],
        resolveFn: ( amsRewardsService : AmsRewardsService ) : ng.IPromise<Array<CodeTypeModel>> => amsRewardsService.getFileFrequency(),
        token    : 'amsFileFrequencies'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyIntegrationsModel> => apiService.get('/company_integrations'),
        token    : 'settings'
      }
    ],
    url: '/ams-rewards-settings'
  }
];